import Upload from "./Upload";
import UploadExcel from "./UploadExcel";

export default Upload
export { UploadExcel }